export enum LogicalConnector {
  AND = "AND",
  OR = "OR",
}
